// extracted by mini-css-extract-plugin
export default {"star":"similar-to-youN1ujDw","star--favourite":"similar-to-youOHhXW0"};